<template>
  <div class="d-flex flex-column align-start justify-start">
    <p
      class="ma-0 pa-0 font-size-10 font-weight-500 blue-grey--text text--darken-1"
      style="line-height: 10px; margin-bottom: 2px"
    >
      {{ title }}
    </p>

    <div class="d-flex">
      <div class="d-flex align-end me-2">
        <p
          class="ma-0 pa-0 blue-grey--text text--darken-3 font-size-24 font-weight-700"
          style="line-height: 24px;"
        >
          {{ total.text }}
        </p>
      </div>
      <div class="d-flex flex-column">
        <div class="mb-1">
          <PercentageChangeChip :percentageChange="percentageChange" />
        </div>
        <p
          class="ma-0 pa-0 font-size-10 font-weight-400 blue-grey--text text--darken-1"
          style="line-height: 10px;"
        >
          <span class="font-weight-600">
            {{ difference.value }}
          </span>
          {{ difference.text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PercentageChangeChip from '../SharedComponents/PercentageChangeChip.vue'

export default {
  name: 'Trend',

  components: { PercentageChangeChip },

  props: {
    title: String,
    percentageChange: Number,
    total: Object,
    totalLastPeriod: Number,
  },

  computed: {
    ...mapGetters(['language']),

    difference() {
      const diffNumber = this.total.value - this.totalLastPeriod
      const diffText = `${diffNumber > 0 ? '+' : ''}${diffNumber.toLocaleString(
        this.language
      )}`
      return {
        number: diffNumber,
        value: diffText,
        text: this.$t('insights.entity_created_in_this_period'),
      }
    },
  },
}
</script>
